<template>
    <div class="page d-flex">
        <MenuComponent />
        <PackageViewComponent />
    </div>
</template>


<script>
import MenuComponent from '@/components/user/layout/MenuComponent.vue';
import PackageViewComponent from '@/components/user/viewComponent/package/PackageViewComponent.vue';

export default{
	name: 'PackageView',
    components:{
        MenuComponent,
        PackageViewComponent
    }
}
</script>

<style >

</style>